import {
  GET_LIST_DANHSACHKIEMKHO,
  GET_LIST_DANHSACHKIEMKHO_SUCCESS,
  GET_LIST_DANHSACHKIEMKHO_FAILURE,
  UPDATE_SEARCHTDATA_DANHSACHKIEMKHO,
} from "./actionTypes";

export const getListDanhSachKiemKho = (dataSearch) => ({
  type: GET_LIST_DANHSACHKIEMKHO,
  dataSearch,
});
export const getListDanhSachKiemKhoSuccess = (data) => ({
  type: GET_LIST_DANHSACHKIEMKHO_SUCCESS,
  payload: data,
});
export const getListDanhSachKiemKhoFailure = (dataSearch) => ({
  type: GET_LIST_DANHSACHKIEMKHO_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_DANHSACHKIEMKHO,
  payload: data,
});
